import axiosInstance from "@/utils/axios";

export const accountApi = {
  getCurrent: () => axiosInstance.get("/api/account/current"),
};
